import _get from 'lodash/get'
import _pick from 'lodash/pick'
import { isLoggedIn } from '../auth'
import { SET_AUTH_DATA } from '../auth/redux/actions'
import { isPageReady } from '../pages'
import { getLocationPathname } from '../location'
import { SET_LOCATION_DATA } from '../location/redux/actions'
import { SET_PAGE_READY } from '../pages/redux/actions'
import { getConfigDataServer } from '../config'
import { createMenu, getMenusUnder } from '.'
import {
  GET_MENUS_DATA,
  CREATE_MENU,
  getMenusData as getMenusDataAction,
  setMenusData as setMenusDataAction,
  createMenuSuccess as createMenuSuccessAction,
  setMenusProcessing as setMenusProcessingAction,
} from './redux/actions'

export function initMenusList ({ after }) {
  return after([SET_AUTH_DATA, SET_PAGE_READY, SET_LOCATION_DATA], ({ dispatch }) => {
    dispatch(getMenusDataAction())
  }).when(({ state }) => {
    const { auth, page, location } = state
    return isLoggedIn(auth) && isPageReady({ page }) && getLocationPathname(location) === '/manage-menus'
  })
}

export function getMenusDataHandler ({ after }) {
  return after(GET_MENUS_DATA, async ({ state, dispatch, action }) => {
    try {
      const { config, auth } = state
      if (!isLoggedIn(auth)) {
        return
      }
      dispatch(setMenusProcessingAction(true))
      const { payload } = action
      const { language, type, platform } = payload
      const options = {
        auth,
        server: getConfigDataServer(config),
        language,
        type,
        platform,
      }
      const data = await getMenusUnder(options)
      dispatch(setMenusDataAction({
        data: _get(data, 'menus'),
      }))
    } catch (_) {
      dispatch(setMenusProcessingAction(false))
    }
  })
}

export function createMenuHandler ({ after }) {
  return after(CREATE_MENU, async ({ state, dispatch, action }) => {
    try {
      const { config, auth } = state
      if (!isLoggedIn(auth)) {
        return
      }
      dispatch(setMenusProcessingAction(true))
      const { payload } = action
      const filteredProperties = Object.keys(payload).filter((key) => key !== 'updatedAt')
      const newMenu = _pick(payload, filteredProperties)
      const options = {
        auth,
        server: getConfigDataServer(config),
        newMenu,
      }
      const data = await createMenu(options)
      dispatch(createMenuSuccessAction({
        data,
      }))
    } catch (_) {
      dispatch(setMenusProcessingAction(false))
    }
  })
}
